class MatchingSuccessSound {
  private playableElement: HTMLAudioElement
  /**
   * constructor should be called only once per page load
   */
  constructor() {
    // load sound files
    const audio = window.Audio && new Audio()

    if (this.canPlay(audio, 'audio/ogg')) {
      // eslint-disable-next-line @typescript-eslint/no-var-requires
      audio.setAttribute('src', require('../assets/sounds/matching-success.ogg'))
      audio.setAttribute('type', 'audio/ogg')
      audio.load()
      this.playableElement = audio
    } else {
      // eslint-disable-next-line @typescript-eslint/no-var-requires
      audio.setAttribute('src', require('../assets/sounds/matching-success.mp3'))
      audio.setAttribute('type', 'audio/mpeg')
      audio.load()
      this.playableElement = audio
    }
  }

  private canPlay(sound: HTMLAudioElement, type: string) {
    return sound && !!(sound.canPlayType && sound.canPlayType(type).replace(/no/, ''))
  }

  public play() {
    this.playableElement.play()
  }
}
// singleton pattern to avoid double loading of sound files
const matchingSuccessSound = new MatchingSuccessSound()

export default matchingSuccessSound
